/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbButton, AbButtonType } from "abreact/misc/AbButton";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
export function AbShowMoreTextLink(props) {
  const linkText = props.isExpanded ? AbReactResources.abShowMoreText_less() : AbReactResources.abShowMoreText_more();
  const className = StringUtils.cssClassStr("ab-show-more-text-link", props.isExpanded ? "ab-show-more-text-link-expanded" : "ab-show-more-text-link-collapsed");
  return /*#__PURE__*/React.createElement(AbButton, {
    type: AbButtonType.LINK,
    label: linkText,
    className: className,
    onClick: () => props.onClick()
  });
}
//# sourceMappingURL=AbShowMoreTextLink.js.map
